import groq from 'groq';

import { RICH_TEXT } from '../common';

export const MITOPURE_SOLUTION = groq`
  _type,
  title,
  showMitopureLogo,
  description[] {
    ${RICH_TEXT}
  }
`;

export const MITOPURE_SOLUTION_BLOCK = groq`
  _type == 'mitopureSolution' => @-> {
    ${MITOPURE_SOLUTION}
  }
`;
